// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3HQIZ","notes":"Notes_notes__2nwSj"};